const setFocusOnFirstElement = (element) => {
  const firstActionableElement = element.querySelector(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  firstActionableElement == null ? void 0 : firstActionableElement.focus();
};
const returnFocusToButtonElement = (element) => {
  const focusToReturnTo = element.querySelector("button");
  if (focusToReturnTo) {
    focusToReturnTo.focus();
  } else {
    element.focus();
  }
};
const handleTabKeyDown = (event, popoverContentRef, buttonRef, closePopover) => {
  var _a;
  const { key, shiftKey } = event;
  if (key === "Tab" && popoverContentRef && popoverContentRef.current) {
    const nextElement = (_a = buttonRef.current) == null ? void 0 : _a.nextElementSibling;
    const actionableElements = queryActionableElements(
      popoverContentRef.current
    );
    if (actionableElements.length === 0) {
      closePopover();
      (!nextElement || shiftKey) && event.preventDefault();
    } else {
      const lastElement = actionableElements[actionableElements.length - 1];
      const firstElement = actionableElements[0];
      const startOfTheContent = shiftKey && document.activeElement === firstElement;
      const endOfTheContent = !shiftKey && document.activeElement === lastElement;
      if (endOfTheContent) {
        closePopover();
        !nextElement && event.preventDefault();
      }
      if (startOfTheContent) {
        closePopover();
      }
    }
  }
};
const queryActionableElements = (element) => {
  return element.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
};
export {
  handleTabKeyDown,
  queryActionableElements,
  returnFocusToButtonElement,
  setFocusOnFirstElement
};
